import type { SortOrderItem } from "src/components/ReactiveTable/RtSort";

import {
  defaultFilterSearchFieldType,
  filterSearchOrder,
  type ZFilterSearchSortItem,
} from "../types/ZFilterSearchTypes";

export type ResolveSortFieldType = (
  columnKey: string,
) => ZFilterSearchSortItem["fieldType"];

const tableSortToFilterOrder: Record<
  SortOrderItem["mode"],
  ZFilterSearchSortItem["order"]
> = {
  ascend: filterSearchOrder.ASC,
  descend: filterSearchOrder.DESC,
};

const resolveSortFieldTypeDefault = (
  columnKey: string,
): ZFilterSearchSortItem["fieldType"] =>
  columnKey.includes(".") ? "SPEC" : defaultFilterSearchFieldType;

export const mapTableSortToFilterSort = (
  sortOrder: SortOrderItem[] | undefined,
  resolveSortFieldType: ResolveSortFieldType = resolveSortFieldTypeDefault,
): ZFilterSearchSortItem[] | undefined =>
  sortOrder?.map((item) => ({
    field: item.columnKey,
    fieldType: resolveSortFieldType(item.columnKey),
    order: tableSortToFilterOrder[item.mode],
  }));
